import { __decorate, __metadata } from "tslib";
import { Component, Inject, Provide } from "vue-property-decorator";
import LvDrawerLayout, { SYM_LV_DRAWER_LAYOUT } from "../drawer-layout/LvDrawerLayout.vue";
import { UIComponent } from "../UIComponent";
/**
 * Injection symbol provided by the LvDrawerMenu component
 */
export const SYM_LV_DRAWER_MENU = Symbol("LvDrawerMenu");
export const COMPONENT_NAME = "LvDrawerMenu";
/**
 * A menu component for the drawer layout
 */
let LvDrawerMenu = class LvDrawerMenu extends UIComponent {
    get self() {
        return this;
    }
};
__decorate([
    Inject(SYM_LV_DRAWER_LAYOUT),
    __metadata("design:type", LvDrawerLayout)
], LvDrawerMenu.prototype, "drawerLayout", void 0);
__decorate([
    Provide(SYM_LV_DRAWER_MENU),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], LvDrawerMenu.prototype, "self", null);
LvDrawerMenu = __decorate([
    Component({
        name: COMPONENT_NAME,
    })
], LvDrawerMenu);
export default LvDrawerMenu;
//# sourceMappingURL=script.js.map